import React from 'react';
import { t } from '../../../i18n';
import { Mutation, Query } from 'react-apollo';
import {withRouter} from "react-router-dom";
import queries from '../../../queries';

function RankingCellEditor({ cell, ...props }) {

    const projectId = props.match.params.projectId;

    const cellId = cell.id;

    return (
        <Query query={queries.cells.ranking.get} variables={{ id: cellId }}>
            {({ loading, error, data, refetch }) => {
                if (loading) return <p>{t('ui.common.loading')}</p>;
                if (error) return <p>Error: {error.message}</p>;

                const rankingCell = data.rankingCell;

                return (
                    <Mutation mutation={queries.cells.ranking.update} refetchQueries={[{ query: queries.cells.ranking.get, variables: { id: cellId } }]}>
                        {
                            (updateRankingCell) => {
                                return(
                                    <>
                                        <h3>Edit Ranking Cell</h3>
                                        <form onSubmit={(e) => {
                                            e.preventDefault();
                                            const input = {
                                                id: cellId,
                                                background_color: e.target.background_color.value,
                                                text_color: e.target.text_color.value,
                                                border_color: e.target.border_color.value,
                                                size: parseInt(e.target.size.value),
                                                game_id: e.target.game_id.value
                                            };
                                            updateRankingCell({ variables: { input } }).then(() => {
                                                refetch();
                                            });
                                        }}>
                                            <Query query={queries.projects.getProjectWithGames} variables={{ id: projectId }}>
                                                {
                                                    ({ loading: projectLoading, error: projectError, data: projectData }) => {
                                                        if (projectLoading) return <p>Loading project...</p>;
                                                        if (projectError) return <p>Error loading project: {projectError.message}</p>;

                                                        const project = projectData.project;
                                                        return (
                                                            <label>
                                                                Game:
                                                                <select required name="game_id" defaultValue={rankingCell.game_id}>
                                                                    <option>
                                                                        Select a game
                                                                    </option>
                                                                    {
                                                                        project.games.map(game => (
                                                                            <option key={game.id} value={game.id}>
                                                                                {game.id} - {game.game_type}
                                                                            </option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </label>
                                                        );
                                                    }
                                                }
                                            </Query>
                                            <br/>
                                            <label>
                                                Background Color:
                                                <input type="color" name="background_color" defaultValue={rankingCell.background_color} />
                                            </label>
                                            <br />
                                            <label>
                                                Text Color:
                                                <input type="color" name="text_color" defaultValue={rankingCell.text_Color} />
                                            </label>
                                            <br />
                                            <label>
                                                Border Color:
                                                <input type="color" name="border_color" defaultValue={rankingCell.border_color} />
                                            </label>
                                            <br />
                                            <label>
                                                Size:
                                                <input type="number" name="size" defaultValue={rankingCell.size} />
                                            </label>
                                            <br />
                                            <h4>Display Fields</h4>
                                            {
                                                rankingCell.display_fields.map(field => (
                                                    <Mutation key={field.id} mutation={queries.cells.ranking.deleteDisplayField} refetchQueries={[{ query: queries.cells.ranking.get, variables: { id: cellId } }]}>
                                                        {(deleteDisplayField) => (
                                                            <div>
                                                                <span>{field.name}</span>
                                                                <button type="button" onClick={() => deleteDisplayField({ variables: {id: field.id } })}>Delete</button>
                                                            </div>
                                                        )}
                                                    </Mutation>
                                                ))
                                            }
                                            <Mutation mutation={queries.cells.ranking.createDisplayField}>
                                                {(createDisplayField) => (
                                                    <form onSubmit={(e) => {
                                                        e.preventDefault();
                                                        const input = {
                                                            name: e.target.name.value,
                                                            cell_id: cellId
                                                        };
                                                        createDisplayField({ variables: { input } }).then(() => {
                                                            refetch();
                                                        });
                                                    }}>
                                                        <label>
                                                            New Display Field:
                                                            <input type="text" name="name" required />
                                                        </label>
                                                        <button type="submit">Add</button>
                                                    </form>
                                                )}
                                            </Mutation>
                                            <button type="submit">Save</button>
                                        </form>
                                    </>
                                );
                            }
                        }
                        
                    </Mutation>
                );
            }}

        </Query>
    );
};

export default withRouter(RankingCellEditor);